import { FeatureGates, useFeatureGate } from '@services/statsig';

/**
 * Statsig gate for the appointment-labels feature (GDN-1968). When off, every
 * labels surface is hidden: the calendar "group by label" lens (including any
 * persisted lens state), the event-block label icons, the labels rows in the
 * appointment popover / sidebar / create modal, the appointment-type default
 * labels, and the catalog page.
 */
export const useAppointmentLabelsEnabled = (): boolean =>
  useFeatureGate(FeatureGates.APPOINTMENT_LABELS);
